"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _coreDecorators = require("core-decorators");
/*!
 * Copyright (c) 2015-2020 Cisco Systems, Inc. See LICENSE file.
 */

/**
 * @private
 * @returns {function}
 */
function emptyDecorator() {
  return function noop() {
    /* eslint no-empty:[0] */
  };
}
var exportedDeprecated = process.env.NODE_ENV === 'production' ? emptyDecorator : _coreDecorators.deprecated;
var _default = exports.default = exportedDeprecated;
//# sourceMappingURL=deprecated.js.map
